import { Injectable, signal } from '@angular/core';

export type HintLink = {
  url: string;
  title: string;
  label: string;
};

export type GlobalMessageElement = {
  general: string;
  hint_link?: HintLink;
  displayInquiry?: boolean;
};

export type GlobalMessage = {
  status: string;
  message: GlobalMessageElement;
};

@Injectable({
  providedIn: 'root',
})
export class GlobalMessageService {
  private readonly _globalMessage = signal<GlobalMessage | null>(null);
  readonly globalMessage = this._globalMessage.asReadonly();

  setErrorMessage(messages: GlobalMessageElement): void {
    this._globalMessage.set({ status: 'error', message: messages });
  }

  setSuccessMessage(message: string): void {
    this._globalMessage.set({
      status: 'success',
      message: { general: message },
    });
  }

  delete(): void {
    this._globalMessage.set(null);
  }
}
